import PropTypes from 'prop-types';
import styled from 'styled-components';
// Components
import Header from './Header';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Main = styled.main`
  flex: 1;
  height: 100%;
`;

function Layout({ header = null, children }) {
  return (
    <Wrapper>
      {header ? <Header>{header}</Header> : null}
      <Main>{children}</Main>
    </Wrapper>
  );
}

Layout.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default Layout;
